import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchRequestSubset,
    SearchProviderFieldType, ISearchProviderField
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


const vUI_AppModule_Search_Fields: {[id:string]: ISearchProviderField } = {
    APPMODULE_SHORTNAME:   {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id',             columnResourceName: 'colId',      alignment: HorizAlignment.Center}, domainOptions: {}},
    APPMODULE_NAME:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'AppModule Name', columnResourceName: 'colName',    alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    APP_ID:                {type: SearchProviderFieldType.string, renderOptions: { columnName: 'APP Id',         columnResourceName: 'colAppId',   alignment: HorizAlignment.Left}, domainOptions: {}},
    APP_NAME:              {type: SearchProviderFieldType.string, renderOptions: { columnName: 'APP NAME',       columnResourceName: 'colAppName', alignment: HorizAlignment.Left}, domainOptions: {}},
    SORT_ORDER:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Sort',           columnResourceName: 'colSort',    alignment: HorizAlignment.Left, numberFormat: "#,##0", columnWidthCharacters: 10}, domainOptions: { maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const UIAppModuleSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_UI_APPMODULE_ID',
                id_ui: 'APPMODULE_SHORTNAME',
                name:  'APPMODULE_NAME'},

    searchProviderFields: vUI_AppModule_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_AppModule_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}

const UIAppModuleSearchAppModuleByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "UIAppModuleSearchAppModuleByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'APPMODULE_SHORTNAME', renderOptions: { }},
        {profileFilterName: 'Name',   searchProviderFieldId: 'APPMODULE_NAME', renderOptions: { }},
        {profileFilterName: 'App Name',   searchProviderFieldId: 'APP_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'APPMODULE_SHORTNAME','APPMODULE_NAME','APP_ID','APP_NAME','SORT_ORDER',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: UIAppModuleSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const UIAppModuleSearch: ISearch = {
    searchName: "Find App Module",
    renderOptions: { ui5ResourceId: "UIAppModuleSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [UIAppModuleSearchAppModuleByName]
}

PAEnvironment.registerBusinessObjectSearch("UIAppModuleBO", "AppModule", UIAppModuleSearch, "App Module Search")

export {UIAppModuleSearch}